import React from "react";
import { FormattedHTMLMessage } from "react-intl";
import { EmailMessageComponent } from "./EmailMessageComponent";
import { EmailLookupResponse, EmailLookupStatus } from "./types";

interface EmailLookupResponseMessagesProps {
  emailLookupResponse: EmailLookupResponse | null;
  onResendClick?: () => Promise<void>;
  onHandleClickLink?: () => Promise<void>;
}

const EmailLookupResponseMessages: React.FC<EmailLookupResponseMessagesProps> = ({
  emailLookupResponse,
  onResendClick = async () => {},
  onHandleClickLink = async () => {},
}) => {
  if (
    emailLookupResponse.status === EmailLookupStatus.FOUND &&
    emailLookupResponse.message === "success"
  ) {
    return (
      <EmailMessageComponent
        title={
          <FormattedHTMLMessage
            id="step.personalInfo.emailFirstCollectInfo.existingVerificationFound.title"
            defaultMessage="You've been here before!"
          />
        }
        message={
          <FormattedHTMLMessage
            id="step.personalInfo.emailFirstCollectInfo.existingVerificationFound.message"
            defaultMessage="Verify@sheerid.com re-sent your confirmation email with details on redeeming your verified offer."
          />
        }
        closing={
          <FormattedHTMLMessage
            id="step.personalInfo.emailFirstCollectInfo.existingVerificationFound.closing"
            defaultMessage="Enjoy!"
          />
        }
        helpRequestResponse="green"
        onResendClick={onResendClick}
      />
    );
  }
  if (
    emailLookupResponse.status === EmailLookupStatus.FOUND &&
    emailLookupResponse.message !== "success"
  ) {
    return (
      <>
        <EmailMessageComponent
          title={
            <FormattedHTMLMessage
              id="step.personalInfo.emailFirstCollectInfo.pendingVerification.title"
              defaultMessage="Looks like you started."
            />
          }
          message={
            <FormattedHTMLMessage
              id="step.personalInfo.emailFirstCollectInfo.pendingVerification.message"
              defaultMessage="This email is associated with a verification in the works."
            />
          }
          closing={
            <FormattedHTMLMessage
              id="step.personalInfo.emailFirstCollectInfo.pendingVerification.closing"
              defaultMessage="Verify@sheerid.com re-sent our last email to you with next steps."
            />
          }
          helpRequestResponse="blue"
          onResendClick={onResendClick}
        />
        <div className="sid-email-first__need-changes sid-h-small-text">
          <FormattedHTMLMessage
            id="step.personalInfo.emailFirstCollectInfo.needChanges"
            defaultMessage="Need to make changes?"
          />
          <button
            type="submit"
            className="sid-email-first__need-changes-link sid-link"
            onClick={onHandleClickLink}
          >
            <FormattedHTMLMessage
              id="step.personalInfo.emailFirstCollectInfo.proceedHere"
              defaultMessage="Proceed here"
            />
          </button>
        </div>
      </>
    );
  }

  return null;
};

export default EmailLookupResponseMessages;
